import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { fetchAndSortBlogs } from '../utils/blogsHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function BlogPost() {
  const [blogContent, setBlogContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { blogTitle } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const loadBlogData = async () => {
      try {
        // If we have state from navigation, use it
        if (location.state?.fileUrl && location.state?.title) {
          setBlog({
            fileUrl: location.state.fileUrl,
            title: location.state.title
          });
          return;
        }

        // Otherwise, fetch blog metadata and find the matching blog
        const blogs = await fetchAndSortBlogs();
        const matchingBlog = blogs.find(b => encodeURIComponent(b.url_title) === blogTitle);
        
        if (!matchingBlog) {
          throw new Error('Blog not found');
        }

        setBlog({
          fileUrl: matchingBlog.file_url,
          title: matchingBlog.name
        });
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };

    loadBlogData();
  }, [location.state, blogTitle]);

  useEffect(() => {
    const fetchBlogContent = async () => {
      if (!blog?.fileUrl) return;

      try {
        const response = await fetch(blog.fileUrl);
        if (!response.ok) throw new Error('Failed to fetch blog content');
        const content = await response.text();
        setBlogContent(content);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlogContent();
  }, [blog]);

  if (isLoading) return <div className="blog-content">Loading...</div>;
  if (error) return <div className="blog-content">Error: {error}</div>;

  return (
    <div className="blog-content-wrapper" style={{ backgroundColor: 'var(--card-bg)' }}>
      <div className="blog-content">
        <button onClick={() => navigate('/blogs')} className="back-button">
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Blogs
        </button>
        {blog?.title && <h1>{blog.title}</h1>}
        <ReactMarkdown>{blogContent}</ReactMarkdown>
      </div>
    </div>
  );
}

export default BlogPost; 